import { render, staticRenderFns } from "./ContentCardSmall.vue?vue&type=template&id=4e1bfb01"
import script from "./ContentCardSmall.vue?vue&type=script&lang=js"
export * from "./ContentCardSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports